import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormControl,
  ControlContainer,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MatSelect, MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatOptionModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-searchable-dropdown-core",
  templateUrl: "searchable-dropdown-core.component.html",
  styleUrls: ["searchable-dropdown-core.component.scss"],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
})
export class SearchableDropdownCoreComponent implements OnChanges {
  @ViewChild("search") searchTextBox: ElementRef;
  @ViewChild("thisSelect") selectElement: MatSelect;
  selectFormControl = new FormControl();
  searchTextBoxControl = new FormControl();
  selectedValues: selectionOption[] = [];
  valuesChanged = false;

  @Input() appearance: string;
  @Input() inputData: InputData;
  @Input() selectIsOpened = false;
  @Output() selectValueChanged: EventEmitter<any> = new EventEmitter();

  data: selectionOption[];

  filteredOptions: Observable<any[]>;

  ngOnChanges(changes: SimpleChanges): void {
    this.selectFormControl.reset();
    this.selectedValues = [];
    this.data = this.inputData.choices.filter((choice) => {
      return choice.name && choice.value;
    });
    if (
      this.inputData.preSelectedValues &&
      this.inputData.preSelectedValues.length > 0
    ) {
      this.selectFormControl.patchValue(this.inputData.preSelectedValues);
    }
    this.filteredOptions = this.searchTextBoxControl.valueChanges.pipe(
      startWith<string>(""),
      map((name) => this._filter(name)),
    );
  }

  private _filter(name: string): selectionOption[] {
    const filterValue = name.toLowerCase();
    // Set selected values to retain the selected checkbox state
    this.setSelectedValues();
    this.selectFormControl.patchValue(this.selectedValues);
    return this.data.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0,
    );
  }

  /**
   * Remove from selected values based on uncheck
   */
  selectionChange(event): void {
    if (event.isUserInput) {
      if (event.source.selected === false) {
        const index = this.selectedValues.indexOf(event.source.value);
        this.selectedValues.splice(index, 1);
      } else if (event.source.selected === true) {
        this.selectedValues.push(event.source.value);
      }
      this.valuesChanged = true;
    }
  }

  openedChange(e): void {
    // Set search textBox value as empty while opening selectBox
    this.searchTextBoxControl.patchValue("");
    // Focus to search textBox while clicking on selectBox
    if (e === true) {
      this.searchTextBox.nativeElement.focus();
      this.valuesChanged = false;
    } else if (e === false && this.valuesChanged === true) {
      this.selectValueChanged.emit(this.selectedValues);
    }
  }

  /**
   * Clearing search textBox value
   */
  clearSearch(event): void {
    event.stopPropagation();
    this.searchTextBoxControl.patchValue("");
  }

  /**
   * Set selected values to retain the state
   */
  setSelectedValues(): void {
    if (this.selectFormControl.value) {
      this.selectFormControl.value.forEach((e) => {
        if (this.selectedValues.indexOf(e) === -1) {
          this.selectedValues.push(e);
        }
      });
    }
  }

  handleInput(event: KeyboardEvent): void {
    event.stopPropagation();
  }
}

export type selectionOption = { name: string; value: number | string };

export interface InputData {
  choices: selectionOption[];
  title: string;
  preSelectedValues?: selectionOption[];
}
// Copyright 2018 Google Inc. All Rights Reserved.
// Use of this source code is governed by an MIT-style license that
//  can be found in the LICENSE file at http://angular.io/license
